import { Prop } from '@typegoose/typegoose'
import { InputType } from 'type-graphql'
@InputType('BasicAuthInput')
export class BasicAuth {
  @Prop({ type: String })
  password: string

  @Prop({ type: String })
  username: string

  @Prop({ type: String })
  picture?: string

  @Prop({ type: String })
  email?: string

  @Prop({ type: String })
  name?: string

  @Prop({ type: String })
  resetCodeHash?: string

  @Prop({ type: Date })
  resetCodeExpiresAt?: Date

  @Prop({ type: Number })
  resetCodeFailedAttempts?: number
}
